import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveDirective as _resolveDirective, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex flex-wrap align-items-center max-sm-text-nowrap mb-2" }
const _hoisted_8 = { class: "text-gray-900 fs-2 fw-bolder text-uppercase" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_12 = {
  key: 0,
  class: "text-gray-900 fs-2 fw-bold"
}
const _hoisted_13 = {
  key: 1,
  class: "text-gray-900 fs-2 fw-light"
}
const _hoisted_14 = { class: "d-flex align-items-center flex-wrap fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "svg-icon mx-1" }
const _hoisted_18 = { class: "fw-bolder" }
const _hoisted_19 = { class: "d-flex align-items-center mb-3" }
const _hoisted_20 = { class: "svg-icon" }
const _hoisted_21 = { class: "fw-bolder" }
const _hoisted_22 = { class: "d-flex gap-2" }
const _hoisted_23 = { class: "position-absolute end-0 top-0 m-2" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_26 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_27 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-250px py-3",
  "data-kt-menu": "true"
}
const _hoisted_28 = { class: "menu-link px-3" }
const _hoisted_29 = { class: "d-flex gap-2 my-4" }
const _hoisted_30 = { class: "me-0" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_33 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_34 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-250px py-3",
  "data-kt-menu": "true"
}
const _hoisted_35 = { class: "menu-link px-3" }
const _hoisted_36 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_37 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_38 = { class: "d-flex flex-column gap-3 flex-wrap mb-3" }
const _hoisted_39 = { class: "d-flex gap-3 w-100" }
const _hoisted_40 = {
  key: 0,
  class: "d-flex flex-column flex-1"
}
const _hoisted_41 = { class: "fs-4 fw-bold" }
const _hoisted_42 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_43 = {
  key: 1,
  class: "d-flex flex-column flex-1"
}
const _hoisted_44 = { class: "fs-4 fw-bold" }
const _hoisted_45 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_46 = {
  key: 2,
  class: "d-flex flex-column flex-1"
}
const _hoisted_47 = { class: "fs-4 fw-bold" }
const _hoisted_48 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_49 = { class: "d-flex flex-column" }
const _hoisted_50 = { class: "fs-4 fw-bold" }
const _hoisted_51 = { class: "fw-bolder text-dark" }
const _hoisted_52 = { class: "fw-normal fs-6" }
const _hoisted_53 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_54 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_55 = { class: "fs-4 fw-bold mw-200px text-line-clamp-1 break-all" }
const _hoisted_56 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_57 = { class: "d-flex flex-wrap" }
const _hoisted_58 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = { class: "fs-4 fw-bold" }
const _hoisted_61 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_62 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_63 = { class: "d-flex align-items-center" }
const _hoisted_64 = { class: "fs-4 fw-bold" }
const _hoisted_65 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_66 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_67 = { class: "d-flex align-items-center" }
const _hoisted_68 = { class: "fs-4 fw-bold" }
const _hoisted_69 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_70 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_71 = { class: "d-flex align-items-center" }
const _hoisted_72 = { class: "fs-4 fw-bold" }
const _hoisted_73 = { class: "fw-bolder text-dark" }
const _hoisted_74 = { class: "fw-normal fs-6" }
const _hoisted_75 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_76 = {
  key: 3,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = { class: "fs-4 fw-bold mw-200px text-line-clamp-1 break-all" }
const _hoisted_79 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_80 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold" }
const _hoisted_81 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_82 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_83 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_86 = { class: "d-flex flex-column gap-7 gap-lg-10" }
const _hoisted_87 = { class: "d-flex flex-column flex-xl-row gap-7 gap-lg-10" }
const _hoisted_88 = { class: "card card-flush py-4 flex-1 overflow-hidden min-h-200px" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute bottom-0 end-0 opacity-10 pe-none text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/ecommerce/ecm006.svg",
    class: "w-150px"
  })
], -1)
const _hoisted_90 = { class: "card-header" }
const _hoisted_91 = { class: "card-title" }
const _hoisted_92 = {
  key: 0,
  class: "card-body fs-6 pt-0"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_97 = { class: "card card-flush py-4 flex-1 overflow-hidden min-h-200px" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute bottom-0 end-0 opacity-10 pe-none text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/duotune/ecommerce/ecm001.svg",
    class: "w-150px"
  })
], -1)
const _hoisted_99 = { class: "card-header" }
const _hoisted_100 = { class: "card-title" }
const _hoisted_101 = { class: "card-body fs-6 pt-0" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_105 = {
  key: 0,
  class: "card card-flush py-4 flex-1 overflow-hidden"
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute bottom-0 end-0 opacity-10 pe-none text-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/custom/payment.svg",
    class: "w-150px"
  })
], -1)
const _hoisted_107 = { class: "card-header" }
const _hoisted_108 = { class: "card-title" }
const _hoisted_109 = {
  key: 0,
  class: "svg-icon svg-icon-3 ms-2 cursor-pointer",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_update_payment_method"
}
const _hoisted_110 = { class: "card-body fs-6 pt-0" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_common_tree_menu = _resolveComponent("common-tree-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_UpdateAddress = _resolveComponent("UpdateAddress")!
  const _component_update_payment_method = _resolveComponent("update-payment-method")!
  const _component_UpdateMerchant = _resolveComponent("UpdateMerchant")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    (_ctx.isAdd)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.t("orderRequest.newOrderRequest")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t("common.orderRequest")), 1)),
                    _hoisted_11
                  ]),
                  (_ctx.OrderRequestOverviewData.request_number)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "#" + _toDisplayString(_ctx.OrderRequestOverviewData.request_number), 1))
                    : _createCommentVNode("", true),
                  (
                    !_ctx.isAdd &&
                    _ctx.OrderRequestOverviewData.__show.external_order_number
                      .length > 0
                  )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " / #" + _toDisplayString(_ctx.CommonArrayToString(
                      _ctx.OrderRequestOverviewData.__show.external_order_number
                    )), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_window_resize, null, {
                    sm: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge text-uppercase position-absolute start-0 top-0", 
                        _ctx.getOrderRequestProgressClass(
                          _ctx.OrderRequestOverviewData.order_progress
                        )
                      ])
                      }, _toDisplayString(_ctx.OrderRequestOverviewData.__show.order_progress), 3)
                    ]),
                    lg: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge text-uppercase ms-2", 
                        _ctx.getOrderRequestProgressClass(
                          _ctx.OrderRequestOverviewData.order_progress
                        )
                      ])
                      }, _toDisplayString(_ctx.OrderRequestOverviewData.__show.order_progress), 3)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("span", {
                    innerHTML: 
                    _ctx.t('orderRequest.overviewSubTitle', [
                      _ctx.OrderRequestOverviewData.__show.channel,
                      _ctx.OrderRequestOverviewData.__show.settlement_entity_name,
                    ])
                  
                  }, null, 8, _hoisted_15), [
                    [_vShow, !_ctx.isAdd]
                  ]),
                  _withDirectives(_createElementVNode("span", {
                    innerHTML: 
                    _ctx.t('orderRequest.plsSelectMerchant', [
                      _ctx.OrderRequestOverviewData.__show.channel_type,
                      _ctx.OrderRequestOverviewData.__show.merchant
                        ? _ctx.OrderRequestOverviewData.__show.channel
                        : _ctx.t('common.plsSelect'),
                      _ctx.OrderRequestOverviewData.__show.settlement_entity_name,
                    ])
                  
                  }, null, 8, _hoisted_16), [
                    [_vShow, _ctx.isAdd]
                  ]),
                  (!_ctx.isDoubleSale)
                    ? (_openBlock(), _createBlock(_component_window_resize, { key: 0 }, {
                        lg: _withCtx(() => [
                          _createElementVNode("span", _hoisted_17, [
                            _createVNode(_component_inline_svg_icon, {
                              class: "w-24px h-24px",
                              src: "media/icons/duotune/communication/com006.svg"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.OrderRequestOverviewData.__show.representative.name), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_window_resize, null, {
                  sm: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, [
                        _createVNode(_component_inline_svg_icon, {
                          class: "w-24px h-24px",
                          src: "media/icons/duotune/communication/com006.svg"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.OrderRequestOverviewData.__show.representative.name), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_window_resize, null, {
                sm: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (
                        _ctx.OrderRequestOverviewData.order_progress ===
                          _ctx.OrderRequestProgress.New ||
                        _ctx.OrderRequestOverviewData.order_progress ===
                          _ctx.OrderRequestProgress.Requested
                      )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
                            "data-kt-menu-trigger": "click",
                            "data-kt-menu-placement": "bottom-end",
                            disabled: _ctx.loading || _ctx.options.downloadDisabled
                          }, [
                            (_ctx.options.downloadDisabled || _ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                              : (_openBlock(), _createElementBlock("i", _hoisted_26))
                          ], 8, _hoisted_24))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", {
                          class: "menu-item px-3",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileExport && _ctx.fileExport(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.t("orderRequest.downloadref")), 1)
                        ])
                      ])
                    ])), [
                      [_directive_auth, { auth: ['export'] }]
                    ])
                  ])
                ]),
                lg: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_common_tree_menu, {
                      trees: _ctx.OrderRequestOverviewData.relation_requests,
                      treesNumber: 
                      _ctx.OrderRequestOverviewData.relation_requests_count
                    
                    }, null, 8, ["trees", "treesNumber"]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                      (
                        _ctx.OrderRequestOverviewData.order_progress ===
                          _ctx.OrderRequestProgress.New ||
                        _ctx.OrderRequestOverviewData.order_progress ===
                          _ctx.OrderRequestProgress.Requested
                      )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
                            "data-kt-menu-trigger": "click",
                            "data-kt-menu-placement": "bottom-end",
                            disabled: _ctx.loading || _ctx.options.downloadDisabled
                          }, [
                            (_ctx.options.downloadDisabled || _ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                              : (_openBlock(), _createElementBlock("i", _hoisted_33))
                          ], 8, _hoisted_31))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", {
                          class: "menu-item px-3",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fileExport && _ctx.fileExport(...args)))
                        }, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.t("orderRequest.downloadref")), 1)
                        ])
                      ])
                    ])), [
                      [_directive_auth, { auth: ['export'] }]
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_window_resize, null, {
                  sm: _withCtx(() => [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        (
                          _ctx.OrderRequestOverviewData.request_date && !_ctx.isDoubleSale
                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.formatDate(_ctx.OrderRequestOverviewData.request_date)), 1),
                              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                          _ctx.OrderRequestOverviewData.business_date && _ctx.isDoubleSale
                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.formatDateOriginTimeZone(
                              _ctx.OrderRequestOverviewData.business_date
                            )), 1),
                              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                          _ctx.OrderRequestOverviewData.request_expiry_date &&
                          !_ctx.isDoubleSale &&
                          !_ctx.isAuditView
                        )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(
                              _ctx.OrderRequestOverviewData.request_expiry_date
                            )), 1)
                              ]),
                              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.t("orderRequest.orderDeadline")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("span", _hoisted_51, [
                            _createTextVNode(_toDisplayString(_ctx.OrderRequestOverviewData.__show.currency_code ==
                            "￥"
                              ? _ctx.$currency.currency(
                                  _ctx.getOrderTotalStart,
                                  0,
                                  ".",
                                  "",
                                  _ctx.OrderRequestOverviewData.__show
                                    .currency_code + " "
                                )
                              : _ctx.$currency.currency(
                                  _ctx.getOrderTotalStart,
                                  0,
                                  ",",
                                  ".",
                                  _ctx.OrderRequestOverviewData.__show
                                    .currency_code + " "
                                )), 1),
                            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.getOrderTotalEnd), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.t("order.skuPcs", [
                            _ctx.OrderRequestOverviewData.__show.total_sku,
                            _ctx.OrderRequestOverviewData.__show.total_pcs,
                          ])), 1)
                      ]),
                      (
                        _ctx.OrderRequestOverviewData.__show.brand.length > 0 &&
                        !_ctx.isAuditView
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.OrderRequestOverviewData.__show.brand.join(", ")), 1),
                            _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.t("salesOrderOverview.brands", [
                            _ctx.OrderRequestOverviewData.__show.brand.length,
                          ])), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  lg: _withCtx(() => [
                    _createElementVNode("div", _hoisted_57, [
                      (
                        _ctx.OrderRequestOverviewData.request_date && !_ctx.isDoubleSale
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.formatDate(_ctx.OrderRequestOverviewData.request_date)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                        _ctx.OrderRequestOverviewData.business_date && _ctx.isDoubleSale
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formatDateOriginTimeZone(
                              _ctx.OrderRequestOverviewData.business_date
                            )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                        _ctx.OrderRequestOverviewData.request_expiry_date &&
                        !_ctx.isDoubleSale &&
                        !_ctx.isAuditView
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(
                              _ctx.OrderRequestOverviewData.request_expiry_date
                            )), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.t("orderRequest.orderDeadline")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("span", _hoisted_73, [
                              _createTextVNode(_toDisplayString(_ctx.OrderRequestOverviewData.__show.currency_code ==
                              "￥"
                                ? _ctx.$currency.currency(
                                    _ctx.getOrderTotalStart,
                                    0,
                                    ".",
                                    "",
                                    _ctx.OrderRequestOverviewData.__show
                                      .currency_code + " "
                                  )
                                : _ctx.$currency.currency(
                                    _ctx.getOrderTotalStart,
                                    0,
                                    ",",
                                    ".",
                                    _ctx.OrderRequestOverviewData.__show
                                      .currency_code + " "
                                  )), 1),
                              _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.getOrderTotalEnd), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.t("order.skuPcs", [
                            _ctx.OrderRequestOverviewData.__show.total_sku,
                            _ctx.OrderRequestOverviewData.__show.total_pcs,
                          ])), 1)
                      ]),
                      (
                        _ctx.OrderRequestOverviewData.__show.brand.length > 0 &&
                        !_ctx.isAuditView
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.OrderRequestOverviewData.__show.brand.join(", ")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.t("salesOrderOverview.brands", [
                            _ctx.OrderRequestOverviewData.__show.brand.length,
                          ])), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("ul", _hoisted_80, [
          (_ctx.isDraft)
            ? (_openBlock(), _createElementBlock("li", _hoisted_81, [
                _createVNode(_component_router_link, {
                  to: 
              _ctx.getMerchantOrderRouterPath(_ctx.$route) +
              '/' +
              _ctx.$route.params.id +
              '/add'
            ,
                  replace: "",
                  class: "nav-link text-active-primary me-6",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("common.overview")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isDraft)
            ? (_openBlock(), _createElementBlock("li", _hoisted_82, [
                _createVNode(_component_router_link, {
                  to: 
              _ctx.getMerchantOrderRouterPath(_ctx.$route) +
              '/' +
              _ctx.$route.params.id +
              '/overview'
            ,
                  replace: "",
                  class: "nav-link text-active-primary me-6",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("common.overview")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (
            !_ctx.isOrderRequest ||
            _ctx.OrderRequestOverviewData.order_progress >=
              _ctx.OrderRequestProgress.Confirmed
          )
            ? (_openBlock(), _createElementBlock("li", _hoisted_83, [
                (_ctx.isShowPaymentInfomationTip)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "nav-link text-active-primary ms-0 me-10 py-5 cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showPaymentInfomationTip && _ctx.showPaymentInfomationTip(...args)))
                    }, _toDisplayString(_ctx.t("orderRequest.shipments")), 1))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: 
              _ctx.getMerchantOrderRouterPath(_ctx.$route) +
              '/' +
              _ctx.$route.params.id +
              '/shipments'
            ,
                      replace: "",
                      class: "nav-link text-active-primary me-6",
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("orderRequest.shipments")) + " ", 1),
                        (_ctx.OrderRequestOverviewData.relation_shipment.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, "(" + _toDisplayString(_ctx.OrderRequestOverviewData.relation_shipment.length) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["to"]))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isDraft)
            ? (_openBlock(), _createElementBlock("li", _hoisted_85, [
                _createVNode(_component_router_link, {
                  to: 
              _ctx.getMerchantOrderRouterPath(_ctx.$route) +
              '/' +
              _ctx.$route.params.id +
              '/logs'
            ,
                  replace: "",
                  class: "nav-link text-active-primary me-6",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("common.logs")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _hoisted_89,
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.invoiceAddress")), 1),
              (
                _ctx.OrderRequestOverviewData.order_progress <
                  _ctx.OrderRequestProgress.Rejected &&
                _ctx.OrderRequestOverviewData.relation_shipment.length === 0 &&
                _ctx.OrderRequestOverviewData.merchant !== 0 &&
                _ctx.isEditPage &&
                !_ctx.isAuditView
              )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "svg-icon svg-icon-3 ms-2 cursor-pointer",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modal_update_address",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addressChange(1)))
                  }, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.OrderRequestOverviewData.invoice_address !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.invoice_address.name), 1),
                _hoisted_93,
                _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.invoice_address.address), 1),
                _hoisted_94,
                _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.invoice_address.city), 1),
                _hoisted_95,
                _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.invoice_address.country), 1),
                _hoisted_96,
                _createElementVNode("span", null, "Ust. ID Nr.: " + _toDisplayString(_ctx.OrderRequestOverviewData.__show.invoice_address.vat_no), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_97, [
          _hoisted_98,
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.shippingAddress")), 1),
              (
                _ctx.OrderRequestOverviewData.order_progress <
                  _ctx.OrderRequestProgress.Rejected &&
                _ctx.OrderRequestOverviewData.relation_shipment.length === 0 &&
                _ctx.isEditPage &&
                !_ctx.isAuditView
              )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "svg-icon svg-icon-3 ms-2 cursor-pointer",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modal_update_address",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addressChange(2)))
                  }, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.shipping_address.name), 1),
            _hoisted_102,
            _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.shipping_address.address), 1),
            _hoisted_103,
            _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.shipping_address.city), 1),
            _hoisted_104,
            _createElementVNode("span", null, _toDisplayString(_ctx.OrderRequestOverviewData.__show.shipping_address.country ||
            _ctx.OrderRequestOverviewData.__show.shipping_address.country_iso_2), 1)
          ])
        ]),
        (!_ctx.isDraft)
          ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
              _hoisted_106,
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRequest.paymentMethod")), 1),
                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                    default: _withCtx(() => [
                      (_ctx.isEditPage && !_ctx.isAuditView)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_109, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                (_ctx.OrderRequestOverviewData.relation_payment.payment_method)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString(_ctx.OrderRequestOverviewData.relation_payment.__show.payment_method), 1))
                  : _createCommentVNode("", true),
                _hoisted_112,
                (_ctx.OrderRequestOverviewData.relation_payment.payment_by)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                      (
                _ctx.OrderRequestOverviewData.relation_payment.payment_by ===
                _ctx.OrderRequestPaymentMethod.PrivatePerson
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(_ctx.t("orderRequest.privatePerson", [
                  _ctx.OrderRequestOverviewData.relation_payment.payment_person,
                ])), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString(_ctx.OrderRequestOverviewData.relation_payment.payment_by), 1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_router_view, {
        onGetFormData: _ctx.getFormInfo,
        onChangeTab: _ctx.changeTabIndex,
        onToEdit: _ctx.toEdit,
        loading: _ctx.loading,
        detailData: _ctx.OrderRequestOverviewData,
        isEdit: _ctx.isEdit,
        isAdd: _ctx.isAdd,
        isDraft: _ctx.isDraft,
        tabIndex: _ctx.options.tabIndex
      }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { ref: "childMainRef" }, null, 512))
        ]),
        _: 1
      }, 8, ["onGetFormData", "onChangeTab", "onToEdit", "loading", "detailData", "isEdit", "isAdd", "isDraft", "tabIndex"])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_UpdateAddress, {
      taxRates: _ctx.OrderRequestOverviewData.__show.tax_rates,
      isDraft: _ctx.isDraft,
      addressType: _ctx.addressType,
      merchantId: Number(_ctx.OrderRequestOverviewData.merchant),
      onUpdateList: _ctx.updateAddress
    }, null, 8, ["taxRates", "isDraft", "addressType", "merchantId", "onUpdateList"]),
    _createVNode(_component_update_payment_method, {
      data: _ctx.OrderRequestOverviewData,
      onUpdateList: _ctx.updatePaymentMethod
    }, null, 8, ["data", "onUpdateList"]),
    _createVNode(_component_UpdateMerchant, {
      isDraft: _ctx.isDraft,
      merchantId: Number(_ctx.OrderRequestOverviewData.merchant),
      channelId: Number(_ctx.OrderRequestOverviewData.channel),
      addressType: _ctx.addressType,
      onUpdateList: _ctx.updateMerchant
    }, null, 8, ["isDraft", "merchantId", "channelId", "addressType", "onUpdateList"])
  ], 64))
}